module.exports = __webpack_public_path__ + "static/media/telephone.ecf65fc9.png";